import { Component, Injector, ViewChild, ViewEncapsulation } from '@angular/core';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { FormValidatorService } from 'src/app/core/services/form-validator.service';
import { firstValueFrom } from 'rxjs';
import { Transaction } from '../_types/transaction';
import { TransactionsService } from '../_services/transactions.service';
import { TransactionState } from '../_types/transaction-state';
import { TransactionsStatesService } from '../_services/transactions-states.service';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { Filter, FilterOperation, NotFilter, OrFilter } from 'src/app/core/jsonapi/filter';
import { TransactionType } from '../_types/transaction-type';
import { TransactionsTypesService } from '../_services/transactions-types.service';
import { TransactionLine } from '../_types/transaction-line';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { TransactionLinesComponent } from './transaction-line/transaction-line.component';
import { Rate } from '../../rates/_types/rate';
import { TransactionsLinesService } from '../_services/transactions-lines.service';
import { CasesService } from '../../cases/_services/cases.service';
import { ThirdParty } from '../_types/third-party';
import { ThirdPartiesService } from '../_services/third-parties.service';
import { TransactionLinesJobsComponent } from './transaction-lines-jobs/transaction-lines-jobs.component';
import { TransactionUploadExcelComponent } from './transaction-upload-excel/transaction-upload-excel.component';
import { TransactionsSeriesService } from '../../transactions-series/_services/transactions-series.service';
import { TransactionSerie } from '../../transactions-series/_types/transaction-serie';
import { ComunicationsComponent } from '../../comunications/communications/comunications.component';
import { TemplatesService } from '../../templates/_services/templates.service';
import {File} from '../../common/_types/file'
import { FilesService } from '../../common/_services/files.service';
import { Validators } from '@angular/forms';
import { AffectedsService } from '../../cases/_services/affecteds.service';
import { Tax } from '../../taxes/_types/tax';
import { TaxesService } from '../../taxes/_services/taxes.service';
import { CasesFilesService } from '../../cases/_services/cases-files.service';
import { CaseService } from '../../cases/_types/case-service';
import { CasesServicesService } from '../../cases/_services/cases-services.service';
import { CaseFile } from '../../cases/_types/case-file';
import { environment } from 'src/environment/environment';
import { TransactionFile } from '../_types/transaction-file';
import { TransactionsFilesService } from '../_services/transactions-files.service';
import { LoginService } from '../../login/login.service';
import { GenerateInvoiceComponent } from '../generate-invoice/generate-invoice.component';
import { CasesNotificationsNumbersService } from '../../cases/_services/cases-notifications-numbers.service';
import { CaseNotificationNumber } from '../../cases/_types/case-notification-number';
import { PaymentsMethodsService } from '../../common/_services/payments-methods.service';
import { PaymentMethod } from '../../common/_types/payment-method';
import { BusinessService } from '../../business/_services/business.service';
import { Business } from '../../business/_types/business';
import { OverlayPanel } from 'primeng/overlaypanel';
import { ContractsOutgoingMailResourceType } from '../../companies/_types/contract-outgoing-mail';
import { ContractsService } from '../../companies/_services/contracts.service';
import { RatesService } from '../../rates/_services/rates.service';
import { Capability } from '../../companies/_types/capability';
import { RateLine } from '../../rates/_types/rate-line';
import { TransactionLog } from '../_types/transaction-log';
import { TransactionsLogsService } from '../_services/transactions-logs.service';
import { CaseServiceTransactionLinesComponent } from '../../cases/cases-detail/service/case-service-detail/case-service-transaction-lines/case-service-transaction-lines.component';
import { RateTemplate } from '../../rates/_types/rate-template';
import { RatesTemplatesService } from '../../rates/_services/rates-templates.service';
import { RatesTemplatesLinesService } from '../../rates/_services/rates-templates-lines.service';
import { CompanyRatesService } from '../../companies/_services/companies-rates.service';
import { CompanyRate } from '../../companies/_types/company-rate';
import { WorkerRatesService } from '../../rates/_services/workers-rates.service';
import { WorkerRate } from '../../rates/_types/worker-rate';

@Component({
    selector: 'app-transactions-detail',
    templateUrl: './transactions-detail.component.html',
    styleUrls: ['./transactions-detail.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class TransactionsDetailComponent {

  @ViewChild('op', { static: false }) op?: OverlayPanel;
  //public opFile: CaseFile | null = null;
  public hoveredImage: CaseFile | null = null;
  
  public transactionFormGroup!: RxFormGroup;

  public transaction: Transaction = new Transaction();
  public transactionLines: TransactionLine[] = [];
  public caseNotificationNumbers: CaseNotificationNumber[] = [];
  public totalTransactionLines: number = 0;

  public transactionStates: TransactionState[] = [];
  public transactionSeries: TransactionSerie[] = [];
  public thirdParties: ThirdParty[] = [];
  public transactionType: TransactionType = new TransactionType();  
  public cases: any;

  public type!: string;
  public typeSelected: any = {};

  public loadingTransactionLines: boolean = false;

  public allowWrite: boolean = false;
  public allowDelete: boolean = false;  
  public allowImportExcel: boolean = false;
  public allowImportDocCreateLine: boolean = false;
  public allowShowAdditionalInfo: boolean = false;

  public allowChangeEvenNetSuiteId: boolean = false;
  public allowChangeTransactionState: boolean = false;
  public allowCopyTransactionLines: boolean = false;

  public dialogRef: any;
  public id: string = "";
  public caseId: string = "";
  public caseSelected: any = {}

  public selectedState?:TransactionState;

  public isModal: boolean = false;
  public showStateNotes: boolean = false;
  public notes: string = "";
  public relatedTransactions:  Transaction[] = [];
  public transactionFrom: Transaction |null = null ;

  selectedBudget: Transaction |null = null ;
  filesIdsToSend: string[] = [];
  public filePhoto? : any;
  public payment: any = {};
  public taxes: Tax[] = [];
  public displayPaymentModal: boolean = false;
  public loadingTaxes: boolean = false;
  public caseFiles: any[] = [];
  public caseFilesWithoutService: any[] = [];
  public casesServices: any[] = [];
  private allCaseServices: any[]= [];
  public caseFilesServices: any[] = [];
  public transactionFiles: TransactionFile[] = [];
  public caseServices: CaseService[] = [];
  public transactionFilesIdToPDF:  any[] = [];
  public transactionFilesIdChecked: { [key: string]: any[] } = {};
  public imagesUrl: string = environment.api_gw + 'common/files/';
  public transactionFilesExist: TransactionFile[] = [];
  public paymentsMethods:PaymentMethod[] = [];
  public businesses: Business[] = [];
  public showMessageTransactionFromMigration: string = "";
  public caseTransactionsRelateResumePercent: number = 0;
  public caseTransactionsRelateResume: number = 0;
  public isDialog: boolean = false;
  public transactionActionItems: MenuItem[] = [];  
  public groupByRatelines: any = [];
  public showTax: boolean = true;
  public showTaxCheckbox : boolean = false;
  public groupByCapability: boolean = false;
  public allCapabilities: Capability[] = [];
  public capabilities: Capability[] = [];  
  public rateLines: RateLine[] = [];
  public allRateLines: any;
  public allRates: Rate[] = [];
  public transactionLogs: TransactionLog[] = [];
  
  public rateTemplates: any = [];
  public showSRateTemplates: boolean = false;
  public rateTemplateId: string = "";
  public typesPayment: any[] = [{ name: 'Total', id: 'total' }, { name: 'Parcial', id: 'partial' }]

  constructor(
    private transactionsService: TransactionsService,
    private transactionsStatesService: TransactionsStatesService,
    private transactionsSeriesService: TransactionsSeriesService,
    private transactionsTypesService: TransactionsTypesService,
    private transactionsLinesService: TransactionsLinesService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private route: ActivatedRoute,
    private router: Router,
    private topbarService: TopbarService,
    private formBuilder: RxFormBuilder,
    public formValidationService: FormValidatorService,
    private dialogService: DialogService,
    private casesService: CasesService,
    private contractsService: ContractsService,
    private thirdPartiesService: ThirdPartiesService,
    private injector: Injector,
    private templateService: TemplatesService,
    private filesService: FilesService,
    private affectedsService: AffectedsService,
    private taxesService: TaxesService,
    private casesFilesService: CasesFilesService,
    private casesServicesService: CasesServicesService,
    private transactionsFileService: TransactionsFilesService,
    private loginService: LoginService,
    private caseNotificationNumbersService: CasesNotificationsNumbersService,
    private paymentsMethodsService: PaymentsMethodsService,
    private businessService: BusinessService,
    private ratesService: RatesService,
    private transactionsLogService: TransactionsLogsService,
    private ratesTemplatesService: RatesTemplatesService,
    private ratesTemplatesLinesService: RatesTemplatesLinesService,
    private companyRatesService: CompanyRatesService,
    private workerRatesService: WorkerRatesService
  ) {

    this.dialogRef = this.injector.get(DynamicDialogRef, null);
    const dialogConfig = this.injector.get(DynamicDialogConfig, null);
    if (dialogConfig) {     
      this.id = dialogConfig.data.id;
      this.type = dialogConfig.data.transactionType;
      this.caseId = dialogConfig.data.caseId;
      this.isModal = true;
      this.isDialog = true; 
    } else {
      this.route.params.subscribe(params => {
        this.id= this.route.snapshot.params['id'];  
        this.type = this.route.snapshot.params['type'];
        this.isModal = false;      
      });
    }   

    if (this.id == '00000000-0000-0000-0000-000000000000' || this.id == '00000000-0000-0000-0000-000000000001') {
        this.showMessageTransactionFromMigration = "No se puede acceder a esta transacción.";
        if(!this.isModal) this.topbarService.addBreadcrumb(this.transactionType?.name, "/transactions/"+this.type);
      return;
     } 

    this.transactionFormGroup = this.formBuilder.formGroup<Transaction>(this.transaction) as RxFormGroup;
   
    if(this.type == "outgoing_budget" || //presupuesto cliente
      this.type == "company_outgoing_budget" || //presupuesto compañía
      this.type == "affected_outgoing_budget" || //presupuesto implicado
      this.type == "ingoing_budget_worker" ) //presupuesto operario
    {
      this.allowCopyTransactionLines = true;
    }

  }

  async ngOnInit() {       
  
    //comprobamos permisos
    this.allowWrite = this.loginService.hasPermission(this.type.toUpperCase() + ".WRITE");
    this.allowImportExcel = this.loginService.hasPermission("TRANSACTIONS.IMPORT_EXCEL");
    this.allowImportDocCreateLine = this.loginService.hasPermission("TRANSACTIONS.IMPORT_DOC_CREATE_LINE");
    this.allowDelete = this.loginService.hasPermission(this.type.toUpperCase() + ".DELETE");
    this.allowChangeTransactionState = this.loginService.hasPermission(this.type.toUpperCase() + ".CHANGE_TRANSACTION_STATE");
    //el permiso solo existe en las tres funcionalidades de presupuesto de salida, asi que en el resto de
    //tipos hasPermission devuelve false y la tarjeta no se pinta
    this.allowShowAdditionalInfo = this.loginService.hasPermission(this.type.toUpperCase() + ".SHOW_ADDITIONAL_INFO");
    
    if(this.type == "outgoing_invoice_worker"){
      //facturas a operario
      this.allowChangeEvenNetSuiteId = this.loginService.hasPermission("OUTGOING_INVOICES_WORKER.CHANGE_EVEN_NETSUITE_ID");
    }else if(this.type == "outgoing_invoice"){
      //factuas a cliente
      this.allowChangeEvenNetSuiteId = this.loginService.hasPermission("OUTGOING_INVOICE.CHANGE_EVEN_NETSUITE_ID");
    }else if(this.type == "company_outgoing_invoice"){
      //Facturas a compañía.
      this.allowChangeEvenNetSuiteId = this.loginService.hasPermission("COMPANY_OUTGOING_INVOICE.CHANGE_EVEN_NETSUITE_ID");
    }else if(this.type == "incoming_invoice"){
      //Facturas de operario
      this.allowChangeEvenNetSuiteId = this.loginService.hasPermission("INCOMING_INVOICE.CHANGE_EVEN_NETSUITE_ID");
    }     
    else if(this.type == "company_outgoing_delivery_note" && this.transaction.id){
      //acción para generar una factura que incluya los albaranes seleccionados
      this.topbarService.addAction("Generar factura", "",true, () => {
        this.generateInvoice();
      });
    }

    //si es cualquier tipo de PRESUPUESTO, se muestra la opción de monstrar o no los ivas.
    if(this.type == "outgoing_budget" || this.type == "company_outgoing_budget" || this.type == "affected_outgoing_budget" || this.type == "ingoing_budget_worker"){
      this.showTaxCheckbox = true;
      this.showTax = false;
    }
    
    await this.loadTransactionType();
     if (this.id == '00000000-0000-0000-0000-000000000000' || this.id == '00000000-0000-0000-0000-000000000001') return;

    await this.loadBusinesses();
    await this.loadPaymentsMethods();

    await this.loadTransactionStates();        
     
    if (this.id != null && this.id != '0') {
      await this.loadTransaction(this.id);
      await this.loadTransactionLines();
      await this.loadThirdParties(null);
      try{
        await this.loadCases();
      }catch{
        //nothing
      }
      this.getTransactionLogs();
    }else{
      await this.loadThirdParties(null);
      await this.loadCases();   
      this.transaction.date = new Date();
      this.transaction.paymentDuedate = new Date();
      this.transaction.transactionTypeId = this.transactionType.id!;
      this.transaction.thirdPartyType = this.transactionType.thirdPartyType;
      if(this.caseId != ""){
        this.transaction.caseId = this.caseId;
        var caseData = await firstValueFrom(this.casesService.get(this.caseId, { include: ['contract.business'] }));
        this.transaction.businessId = caseData.contract?.business?.id!;
        if(this.type == "company_outgoing_budget"){
          //obtenemos la compañía del caso          
          this.transaction.thirdPartyId = caseData.companyId;       
          this.transactionFormGroup.get('thirdPartyId')?.disable();          
        }else if (this.type == "outgoing_budget"){
          //Obtenemos el cliente del caso.
          this.transaction.thirdPartyId = caseData.clientId;
          this.transactionFormGroup.get('thirdPartyId')?.disable();
        }
      }  

      //guardamos las condiciones de validez y de pago si es alguno de los tipos de presupuesto
      if(this.type == "outgoing_budget" || this.type == "company_outgoing_budget" || this.type == "affected_outgoing_budget"){
        this.transaction.paymentConditionsNotes = "// 10% ACEPTACIÓN TRABAJOS // 40% INICIO TRABAJOS // 40% CERTIFICACIONES MENSUALES // 10% FINAL OBRA //"
        this.transaction.validityDocNotes = "ESTE PRESUPUESTO NO INCLUYE TASAS O PERMISOS AYUNTAMIENTO.\nVALIDEZ DEL PRESUPUESTO: 60 DÍAS."
      }
      
      this.transactionFormGroup.patchValue(this.transaction);
     
      if(this.type == "company_outgoing_budget"){             
        //this.transactionFormGroup.controls["thirdPartyId"].setValidators([Validators.required]);
        this.transactionFormGroup.get('thirdPartyId')?.addValidators(Validators.required);
      }
    }

    await this.loadServices();
    //IMPORTANTE: NO PONERLO POR ENCIMA DE loadServices(), PORQUE SINO NO CARGA LAS IMAGENES!!!!!!!!!!!
    if(this.transactionType.enablePhotos){
        await this.loadCaseFiles();
    }
    if(this.id != null && this.id != '0') { //MOVIDO aqui porque necesistamos los servicios y no se porqué se bajo aquí.
       if(this.transactionType.enablePhotos){  
        //ficheros ya seleccionados de transacciones
        var filesT = await firstValueFrom(this.transactionsFileService.all({ filter: FilterBuilder.fromObject({transactionId: new Filter(FilterOperation.equals, 'transactionId', '', this.id)}).build()}));
        this.transactionFilesExist = filesT.data;
      
        this.transactionFilesIdToPDF = this.transactionFilesExist.map(x => x.fileId);
        this.transactionFilesIdToPDF.forEach((fileId: any) => {
          var fileCase = this.caseFiles.filter((caseFile: CaseFile) => caseFile.fileId == fileId);
          if(fileCase != null && fileCase.length > 0){
            if(this.transactionFilesIdChecked == null ||this.transactionFilesIdChecked[fileCase[0].caseServiceId] == null || this.transactionFilesIdChecked[fileCase[0].caseServiceId] == undefined)
            {
              this.transactionFilesIdChecked[fileCase[0].caseServiceId] = []; 
            }
            this.transactionFilesIdChecked[fileCase[0].caseServiceId].push(fileId);
          }
        });

      }
      if(this.transactionType.enableFiles){
        await this.loadTransactionFiles();
      }

      this.loadRateLines();

    }

    if(this.type == "company_outgoing_budget" || this.type == "affected_outgoing_budget" || this.type == "outgoing_budget"){
      this.transactionFormGroup.get('date')?.disable();
      this.loadRelatedTransactions(); //Cargamos los relacionados una vez tengamos la información.
    }

    //this.allowWrite = true;//this.loginService.hasPermission("PROVIDERS_WRITE");
    //his.allowDelete = true;//this.loginService.hasPermission("PROVIDERS_DELETE");


  }

  async loadBusinesses() {
    let params:IParamsCollection = {
      sort: ['name']
    };
    let response = await firstValueFrom(this.businessService.all(params));
    this.businesses = response.data;    
  }

  async loadPaymentsMethods() {
    let params:IParamsCollection = {
      sort: ['name']
    };
    let response = await firstValueFrom(this.paymentsMethodsService.all(params));
    this.paymentsMethods = response.data;    
  }


  async loadTransactionFiles(){
    
    let filter = {
      transactionId: new Filter(FilterOperation.equals, 'transactionId', '', this.transaction?.id)
    };
    let params:IParamsCollection = {
      include: ['file'],
      filter: FilterBuilder.fromObject(filter).build()
    };
    let response = await firstValueFrom(this.transactionsFileService.all(params));
    //mostramos los adjuntos del más nuevo al más viejo
    this.transactionFiles = response.data.sort((a, b) =>
      new Date(b.file?.createdAt).getTime() - new Date(a.file?.createdAt).getTime());
  }


  async loadCaseNotificationNumbers(){
    let params: IParamsCollection = {};
    let filters:any = {
      caseId: new Filter(FilterOperation.equals, "caseId", "", this.transaction.caseId, true  ),
    };
    params.filter = FilterBuilder.fromObject(filters).build();
    let response = await firstValueFrom(this.caseNotificationNumbersService.all(params));
    this.caseNotificationNumbers = response.data;    
  }

  async loadCaseFiles() {
      let params: IParamsCollection = {
        include: ['file', 'caseFileCategory'],
        sort: ['-createdAt']
      }
      
      let filters: any = {
        caseId: new Filter(FilterOperation.equals, "caseId"),
        caseFileCategoryId: new Filter(FilterOperation.equals, "caseFileCategoryId")
      };
  
      filters.caseId.value = this.caseId;
 
      params.filter = FilterBuilder.fromObject(filters).build();
  
      let response = await firstValueFrom(this.casesFilesService.all(params));
      this.caseFiles = response.data;
      
      this.caseFilesServices = [];
      this.caseFilesWithoutService = [];
      this.caseFiles.forEach((caseFile: CaseFile) => {
                
        if (caseFile.caseServiceId) {
          let caseService = this.caseServices.find((service: CaseService) => service.id == caseFile.caseServiceId);
          this.caseFilesServices.push({
            id: caseService?.id,
            name: (caseService?.worker?.name + " - " + caseService?.date.toLocaleString(
              'es-ES',
              {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit'
              }
            )),
            realizedTasksDescription: caseService?.realizedTasksDescription,
            pendingTasksDescription: caseService?.pendingTasksDescription,
          });
        } else {
          this.caseFilesWithoutService.push(caseFile);
        }
      });
      // quitar duplicados
      this.caseFilesServices = this.caseFilesServices.filter((v, i, a) => a.findIndex(t => (t.id === v.id)) === i);
      
    }

  async loadServices() {
    if(this.caseId == "" || this.caseId == null) return;
  
    let params: IParamsCollection = {
      sort: ['date']
    }
    let filters: any = {
      caseId: new Filter(FilterOperation.equals, "caseId", "", this.caseId),
    };

    filters.caseId.value = this.caseId;
    params.filter = FilterBuilder.fromObject(filters).build();
    params.include = ['worker', 'capability', /*'equipment', 'cancelCaseServiceReason', 'cancelCaseServiceCause'*/];

    let response = await firstValueFrom(this.casesServicesService.all(params));
    this.caseServices = response.data;
    this.allCaseServices = response.data;
  }
  
  loadMoreTransactionInfo(){
    //Si es de compañia, cargmaos los relacionados o por el caseId o si no por los presupuestos de 
    if(this.type == "company_outgoing_budget" || this.type == "affected_outgoing_budget" || this.type == "outgoing_budget"){
      //TODO: Habría que sacar todas las transacciones que están en un caso de ésta compañía...
      this.loadRelatedTransactions()
    }

    if(this.transactionType.thirdPartyType == "Worker"){
      //filtramos los serivicios del trabajadaor.
      this.caseServices = this.allCaseServices.filter((m:any) => m.workerId == this.transaction.thirdPartyId);
    }
  }

  async loadRelatedTransactions() {
    let paramsTransactions: IParamsCollection = { 
      include: ['transactionState'],
    };

    let filtersTra = {
      caseId: new Filter(FilterOperation.any, "caseId", '' ),
      transactionTypeId: new Filter(FilterOperation.equals, 'transactionType.code', ''),
      transactionStateId: new NotFilter(FilterOperation.equals, 'transactionState.code', '', 'refused'),
      companyId: new Filter(FilterOperation.equals, 'case.companyId', '')
    }

    if(this.type == "company_outgoing_budget"){
      filtersTra.transactionTypeId.value = "ingoing_budget_worker";
      if(this.transaction.thirdPartyId != null){
        filtersTra.companyId.value = this.transaction.thirdPartyId;
      }

    }else if(this.type == "affected_outgoing_budget" || this.type == "outgoing_budget"){
      filtersTra.transactionTypeId.value = "company_outgoing_budget";
    }

    if(this.caseId != ""){
      filtersTra.caseId.value = this.caseId;
    }
    
    paramsTransactions.filter = FilterBuilder.fromObject(filtersTra).build();
    let isBudgetRequiredCaseServices2 = await firstValueFrom(this.transactionsService.all(paramsTransactions));
    this.relatedTransactions = isBudgetRequiredCaseServices2.data;
  }


  async loadTransaction(id: string) {

    this.transaction = await firstValueFrom(this.transactionsService.get(id, { include: ['transactionState', 'case', 'case.clientPolicy', 'thirdParty', 'transactionType', 'business', 'relatedTransaction', 'caseService', 'createdByUser'] }));

    if (this.type=='ingoing_budget_worker'){
      //si es ppto de operario y lo ha creado el operario, no puede borrarse
      if(this.transaction.createdByUser?.isWorker) this.allowDelete = false;
    }

    if(!this.isModal) this.topbarService.setTitle(this.transaction.code);

    this.transactionFormGroup.patchValue(this.transaction);
    if(this.transaction.netSuiteId != null && this.transaction.netSuiteId != "" && !this.allowChangeEvenNetSuiteId){
      this.transactionFormGroup.disable();
      this.transactionFormGroup.get('caseNotificationNumberId')?.enable();
    }

    //si es albaran y esta migrado activamos el bussinesId
    if(this.transactionType.code == "company_outgoing_delivery_note" && this.transaction.externalId != null){
      this.transactionFormGroup.get('businessId')?.enable();
    }

    if((this.type == "company_outgoing_invoice" || this.type == "outgoing_invoice") && this.loginService.hasPermission('COMPANY_OUTGOING_INVOICE.RETURN_GENERATE') && !this.transaction.relatedTransactionId && !this.transaction.isReturn){
      this.topbarService.addAction("Generar abono", "",true, () => {
        this.generatePayment();
      });
    }

    //Si no tiene el permiso necesario, no va a poder modificar el estado de la transacción SOLO EN EL CASO DE LA EDICIÓN DENTRO DE LOS LISTADOS, NO EN EL EXPEDIENTE.
    if(this.allowChangeTransactionState == false && this.isModal == false){  
      this.transactionFormGroup.get('transactionStateId')?.disable();
    }

    this.caseId = this.transaction.caseId!;
    this.updateTransactionActionItems();

    this.onStateChange(this.transaction?.transactionStateId);

     if(this.transactionType.thirdPartyType == "Worker" && this.transaction.thirdPartyId != null){
      //filtramos los serivicios del trabajadaor.
      this.caseServices = this.allCaseServices.filter((m:any) => m.workerId == this.transaction.thirdPartyId);
    }

  }

  updateTransactionActionItems() {
    if (!this.transaction.id) {
      this.transactionActionItems = [];
      return;
    }

    this.transactionActionItems = [
      {
        label: 'Enviar email',
        icon: 'pi pi-envelope',
        command: () => this.exportTransaction(this.transactionType.code!, this.transaction.id!)
      },
      {
        label: 'Descargar xml',
        icon: 'pi pi-download',
        command: () => this.downloadXml(this.transaction.id!)
      }
    ];
  }

  async loadTransactionType(){
    
    let params: IParamsCollection = {            
    }        
    //creamos filtros
    params.filter = FilterBuilder.fromObject({code: new Filter(FilterOperation.equals, 'code', '', this.type)}).build();

    let response = await firstValueFrom(this.transactionsTypesService.all(params));    
    this.transactionType = response.data[0]; 

    //this.topbarService.setTitle("Detalles de "+this.transactionType.name);
    if(!this.isModal) this.topbarService.addBreadcrumb(this.transactionType.name, "/transactions/"+this.type);

    if(this.transactionType.enableTransactionSerie){
      //Cargamos las series del tipo en cuestión
      await this.loadTransactionSeries();
    }            

    if(this.transactionType.enableManualCode){
      this.transactionFormGroup.get('code')?.addValidators(Validators.required);      
    }
  }
  

  async loadTransactionStates() {

    let params: IParamsCollection = {
      sort: ['position'],
    }    

    //creamos filtros
    //params.filter = FilterBuilder.fromObject({transactionTypeId: new Filter(FilterOperation.equals, 'transactionTypeId', '', this.transactionType.id)}).build();  
    params.filter = FilterBuilder.fromObject({
      transactionTypeId: new Filter(FilterOperation.equals, 'transactionTypeId', '', this.transactionType.id),
      active: new Filter(FilterOperation.equals, 'active', '', true)
    }).build();       
    let response = await firstValueFrom(this.transactionsStatesService.all(params));
    this.transactionStates = response.data;

    //establecemos el por defecto
    let defaultState = this.transactionStates.filter((state: any) => state.isInitial);
    if(defaultState.length>0){
      this.transaction.transactionStateId = defaultState[0].id!;
      this.transactionFormGroup.patchValue(this.transaction);
    }
  }


  async loadTransactionSeries() {

    let params: IParamsCollection = {            
    }    

    //creamos filtros
    params.filter = FilterBuilder.fromObject({
      transactionTypeId: new Filter(FilterOperation.equals, 'transactionTypeId', '', this.transactionType.id),
      active: new Filter(FilterOperation.equals, 'active', '', true)
    }).build();        
    let response = await firstValueFrom(this.transactionsSeriesService.all(params));
    this.transactionSeries = response.data;

    //establecemos serie por defecto
    let defaultSerie = this.transactionSeries.filter((serie: any) => serie.isDefault);
    if(defaultSerie.length>0){
      this.transaction.transactionSerieId = defaultSerie[0].id!;
      this.transactionFormGroup.patchValue(this.transaction);
    }
  }

  async loadThirdParties(event?: any) {
    let text = "";
    if (event != null) text = event.filter; 
    
    const filters: { [key: string]: any } = {
      thirdPartyType: new Filter(FilterOperation.equals, 'thirdPartyType', '', this.transactionType.thirdPartyType),
      name: new Filter(FilterOperation.contains, 'name', '', text)
      
    };

    if(this.type == "purchase_order"){
      //si es una solicitud de compra, 
      filters["active"] = new Filter(FilterOperation.equals, 'active', '', true);
    }

    if(this.type == "affected_outgoing_budget"){
      //Si es un presupuesto de afectado, hay que filtrar por los afectados del caso.
      //filters["thirdPartyType"] = new Filter(FilterOperation.equals, 'thirdPartyType', '', "Affected");
       let affectedResponse = await firstValueFrom(this.affectedsService.all({ filter: FilterBuilder.fromObject({caseId: new Filter(FilterOperation.equals, "caseId", "", this.caseId)}).build()}));
       var affectedIds = affectedResponse.data.map((af: any) => af.id);
       //Sin afectados (p.ej. el afectado del presupuesto fue borrado) no filtramos por id: un any(id,[]) se serializaría como any(id,'') y el back daría error.
       if(affectedIds.length) filters["id"]= new Filter(FilterOperation.any, 'id', '', affectedIds);
    }

    let params: IParamsCollection = {
      page: { size: 200, number: 1 },
      sort: ['name'],
      filter: FilterBuilder.fromObject(filters).build()
    };
    let response = await firstValueFrom(this.thirdPartiesService.all(params));    
    this.thirdParties = response.data;

    if(this.type == "affected_outgoing_budget"){
      //Si es un afectado, hay que filtrar por los afectados del caso.
      let affectedResponse = await firstValueFrom(this.affectedsService.all({ filter: FilterBuilder.fromObject({caseId: new Filter(FilterOperation.equals, "caseId", "", this.caseId)}).build()}));
      this.thirdParties = this.thirdParties.filter((m: any) => affectedResponse.data.map((af: any) => af.id).includes(m.id));
    }

    if(this.transactionType.thirdPartyType == 'company'|| this.transactionType.thirdPartyType == "client" || this.transactionType.thirdPartyType == "affected"){
      this.loadRelatedTransactions();
    }        

    if(this.transaction.thirdPartyId != null && this.transaction.thirdPartyId != ""){
      if (!this.thirdParties.some(tp => tp.id === this.transactionFormGroup.get('thirdPartyId')?.value)) {
        const thirdParty = await firstValueFrom(this.thirdPartiesService.get(this.transactionFormGroup.get('thirdPartyId')?.value));
        if (thirdParty) {
          //el tercero (p.ej. borrado) no viene en el listado, lo añadimos para que el desplegable pueda
          //mostrarlo seleccionado. Importante crear un array NUEVO sin mutar el actual: p-dropdown compara
          //las opciones con deepEquals y, si mutásemos el array en sitio con push, no detectaría el cambio
          //y no recalcularía la opción seleccionada (el trigger se quedaría vacío hasta reseleccionar).
          this.thirdParties = [...this.thirdParties, thirdParty];
        }
      }
    }
    
  }

  async loadCases() {
    
    if(this.isModal){
      if(this.caseId) this.caseSelected = await firstValueFrom(this.casesService.get(this.caseId));
    }else{
      if(this.transaction.caseId) this.caseSelected = await firstValueFrom(this.casesService.get(this.transaction.caseId));      
    }

    //si la transaccion es de un contrato que tiene integracion de CASER, añadimos la opción de enviar a CASER
    if(this.transaction.id && this.transaction.caseId && this.transactionType.code == "company_outgoing_invoice"){
      //obtenemos el contrato con la integración que tenga
      let contract = await firstValueFrom(this.contractsService.get(this.caseSelected.contractId, { include: ['integration'] }));
      if(contract && contract.integration && contract.integration.code == 'CASER'){
        //añadimos la opción de enviar a caser
        this.transactionActionItems.push({
          label: 'Enviar a CASER',
          icon: 'pi pi-send',
          command: () => this.sendToCaser(this.transaction.id!)
        });
      }
    }

    await this.loadCaseNotificationNumbers();

    if (this.transaction.caseId != null && this.transaction.caseId !== '') {
      /*const existing = this.cases.some((c: any) => c.id === this.transaction.caseId);
    
      if (!existing) {
        const caseFound = await firstValueFrom(this.casesService.get(this.transaction.caseId));
        if (caseFound) {
          this.cases.push(caseFound);
          this.cases = [...this.cases];                     
        }
      }*/
    
      // 🔧 Forzamos que el valor se actualice correctamente
      const currentVal = this.transactionFormGroup.get('caseId')?.value;
    
      if (currentVal !== this.transaction.caseId) {
        this.transactionFormGroup.get('caseId')?.setValue(this.transaction.caseId, { emitEvent: false });
      } else {
        // A veces PrimeNG no detecta que el valor ya coincide, así que lo forzamos con un pequeño retraso
        setTimeout(() => {
          this.transactionFormGroup.get('caseId')?.setValue(this.transaction.caseId);
        }, 0);
      }      
    }
    
  }

  async loadTransactionLines() {
    
    this.loadingTransactionLines = true;
    let params: IParamsCollection = {
        sort: ["lineNumber"],
        page: { size: 9999, number: 1 },
        include: ["rateLine", "rateLine.capability", "caseService.case", "job", "capability"]
    }
    let filters: any = {
      transactionId: new Filter(FilterOperation.equals, "transactionId"),
    };

    filters.transactionId.value = this.transaction.id;
    params.filter = FilterBuilder.fromObject(filters).build();   
    
    let response = await firstValueFrom(this.transactionsLinesService.all(params));
    this.transactionLines = response.data;
    this.totalTransactionLines = response.meta['total'];

    //solo si son presupuestos.
    if(this.type=="company_outgoing_budget" || this.type == "affected_outgoing_budget" || this.type == "ingoing_budget_worker" || this.type == "outgoing_budget"){
      const groupedObject = this.transactionLines.reduce((groups: any, line: TransactionLine) => {
        if(!line.isGroup){
          let rateLine = 'Sin especialidad';
          let capabilityId = 'no-rate-line';
          if(line.rateLineId != null && line.rateLineId != undefined && line.rateLine != null){
            
            rateLine = line.rateLine?.capability?.name;
            capabilityId = line.rateLine?.capabilityId;
          }
          if (!groups[capabilityId]) {
            groups[capabilityId] = [];
          }
          let subtotal = line.subtotal ?? 0;
          subtotal += groups[capabilityId].length == 0 ? 0 : groups[capabilityId].subtotal;
          let taxAmount = line.taxAmount ?? 0;
          taxAmount += groups[capabilityId].length == 0 ? 0 : groups[capabilityId].taxAmount;
          groups[capabilityId] = { description: rateLine, subtotal: subtotal, taxAmount: taxAmount, total: subtotal + taxAmount };
        }
        return groups;
      }, {});
  
      this.groupByRatelines = Object.values(groupedObject);
  
      //si sólo hay una especialidad, que no salga.
      if(this.groupByRatelines.length == 1){
        this.groupByRatelines = [];
      }
    }

    this.loadingTransactionLines = false;
  }

  async loadRelatedTransactionInfo(event: any){
    let id = event.value.id;
      this.transactionFrom = await firstValueFrom(this.transactionsService.get(id, { include: ['transactionState'] }));
      //Cargamos la
      var transactionLines = await firstValueFrom(this.transactionsLinesService.all( { include:['rateLine', "caseService.case"], filter: FilterBuilder.fromObject({transactionId: new Filter(FilterOperation.equals, 'transactionId', '', id)}).build() }));
      if(transactionLines.data == null) {
        this.transactionFrom.transactionLines = [];
      }else{
        this.transactionFrom.transactionLines = transactionLines.data;
      }
            
      this.transaction.relatedTransactionId = this.transactionFrom.id; 
      
      //calculamos la rentabilidad de este con el nuevo.     
      var relatedTransactionSubtotal = this.transactionFrom.subtotal ?? 0;
      var transactionSubtota = this.transaction.subtotal ?? 0;
      this.caseTransactionsRelateResume = (transactionSubtota) - (relatedTransactionSubtotal);
      this.caseTransactionsRelateResumePercent = 0;
      if(transactionSubtota > 0 && relatedTransactionSubtotal == 0) {
        this.caseTransactionsRelateResumePercent = 100;
      }else{
        this.caseTransactionsRelateResumePercent = transactionSubtota > 0 ? (this.caseTransactionsRelateResume * 100) / transactionSubtota : 0;
      }
  }

  async onStateChange(event: any){
    let stateId = event;
    this.selectedState = this.transactionStates.find(state => state.id == stateId);
  }

  async save(saveAndClose: boolean = true) {        

    let valid = this.formValidationService.validateForm(this.transactionFormGroup);
    if (valid) {
      this.transaction = Object.assign(this.transaction, this.transactionFormGroup.value);
      
      //si no tiene id es que es nuevo
      let reload = this.transaction.id == '' || this.transaction.id == null;
      let transaction = await firstValueFrom(this.transactionsService.save(this.transaction));
      this.id = transaction.id!; //actualizamos el id.

      this.messageService.add({ closable: true, severity: 'success', summary: "Transacción guardada correctamente." });

      //Guardamos las imágenes de la transacción
      if(this.transactionFilesIdToPDF.length > 0){

        //let transactionFilesExist = await firstValueFrom(this.transactionsFileService.all({ filter: FilterBuilder.fromObject({transactionId: new Filter(FilterOperation.equals, 'transactionId', '', transaction.id)}).build()}));
        let transactionFilesExistIds = this.transactionFilesExist.map(x => x.fileId);
    
        let toAdd = this.transactionFilesIdToPDF.filter(x => !transactionFilesExistIds.includes(x));
        let toRemove = transactionFilesExistIds.filter(x => !this.transactionFilesIdToPDF.includes(x));

        const addPromises = toAdd.map(fileId => {
          let file = new TransactionFile();
          file.transactionId = transaction.id as string;
          file.fileId = fileId;
          return firstValueFrom(this.transactionsFileService.save(file));
        });

         const removePromises = toRemove.map(fileId => {
          let fileToRemove = this.transactionFilesExist.find(x => x.fileId == fileId);
          return firstValueFrom(this.transactionsFileService.delete(fileToRemove?.id));
        });

        // Esperar a que todas las promesas se completen
        await Promise.all([...addPromises, ...removePromises]);
        this.transactionFilesIdToPDF = [];
      }

      if(saveAndClose){
        if(reload){
          if(!this.isModal){
            await this.router.navigate(['transactions/'+this.type, transaction.id]);
          }
          //window.location.reload();
          this.loadTransaction(transaction.id!);
        }else{
          if(this.isModal){
            this.injector.get(DynamicDialogRef).close(transaction);
          }else{
            this.router.navigate(['transactions/'+this.type]);
          }    
          this.getTransactionLogs();   
        }
      }else{
        this.loadTransaction(transaction.id!);
      }
    
    } else {
      this.messageService.add({ closable: true, severity: 'error', summary: "Error", detail: "Existen errores, por favor revise el formulario de datos." });
    }
  }
  /*
  async opShow($event:any, file:CaseFile){
    this.opFile = file;
    this.op?.show($event);
  }*/

  async delete() {
    if(this.transaction.netSuiteId != null && !this.allowChangeEvenNetSuiteId){
      this.messageService.add({ closable: true, severity: 'info', detail: "No se puede eliminar una transacción que ha sido contabilizada." });
      return;
    }

    this.confirmationService.confirm({
      message: "¿Está seguro que desea eliminar la transacción "+this.transaction.code+"?",
      header: "Eliminar transacción",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.transactionsService.delete(this.transaction.id).subscribe({
          next: (data: any) => {
            this.cancel();
            this.messageService.add({ closable: true, severity: 'success', detail: "Transacción eliminada correctamente." });
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      },
      reject: (error: any) => {
        this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
      }
    });
  }

  cancel() {
    if(this.isModal){
      this.injector.get(DynamicDialogRef).close();
    }else{
      this.router.navigate(['transactions/'+this.type]);
    }    
  }

  async generateInvoice(){
    var dialog = this.dialogService.open(GenerateInvoiceComponent, {
      closable: true,
      modal: true,
      header: 'Generar factura',
      width: '400px',
      data: {
        selectedRowsIds: [this.transaction]
      }
    });
    dialog.onClose.subscribe(async (result:any) => {
      this.loadTransaction(this.transaction.id!);
    });
  }

  // Método para guardar el nuevo orden de columnas  
  async onRowReorder(event:any){
    await this.updateOrderLines();    
  }  

  async updateOrderLines() {
    try {
      var groupCount = 0;
      const promesas = this.transactionLines.map((line, index) => {
        if(line.isGroup){
          groupCount++;
          if(line.description.includes(". ")){
            line.description = line.description.substring(line.description.indexOf(". ")+2);
          }
          line.description = groupCount + ". " + line.description;
        }
        line.lineNumber = index + 1; // Asigna el nuevo orden basado en el índice
        return firstValueFrom(this.transactionsLinesService.save(line)); // Retorna la promesa
      });
  
      // Espera que todas las promesas se resuelvan en paralelo
      await Promise.all(promesas);
      this.loadTransactionLines();
    } catch (error) {
      console.error(`Error al guardar alguna de las líneas: ${error}`);
    }
  }

  // Abre el modal al hacer doble clic en la fila, salvo que el doble clic ocurra
  // dentro de una celda en edición (para poder seleccionar texto en el editor en línea).
  openLineFromRow(event: MouseEvent, isGroup: boolean, transactionLine: TransactionLine | null) {
    if ((event.target as HTMLElement).closest('.p-cell-editing')) return;
    this.editTransactionLine(isGroup, transactionLine, null);
  }

  async editTransactionLine(isGroup: boolean, transactionLine: TransactionLine | null, selectedCapability: any | null, uploadDocument: boolean = false) {
    if(!this.allowWrite) return;

    if(!isGroup && (transactionLine?.jobId != null || (this.transaction.netSuiteId != null && !this.allowChangeEvenNetSuiteId))){
      this.messageService.add({ closable: true, severity: 'info', detail: "No se puede modificar una transacción que ha sido contabilizada." });
      return;
    }
    if(isGroup && this.transaction.netSuiteId != null && !this.allowChangeEvenNetSuiteId){
      this.messageService.add({ closable: true, severity: 'info', detail: "No se puede modificar una transacción que ha sido contabilizada." });
      return;
    }
    
    const ref = this.dialogService.open(TransactionLinesComponent, {
      closable: true,
      header: 'Ficha de línea',
      width: '800px',
      //modal: false, no lo pongo pero podria. No encuentro problemas.
      draggable: true,
      modal: false,
      data: {
        type: this.type,
        isGroup: isGroup,        
        transactionId: this.transaction.id,
        transactionLineId: transactionLine ? transactionLine.id : null,
        lineNumber: transactionLine ? transactionLine.lineNumber : this.totalTransactionLines+1,
        selectedCapability: selectedCapability,
        uploadDocument: uploadDocument
      }
    });

    ref?.onClose.subscribe(async (data: any) => {
      await this.loadTransaction(this.transaction.id!);
      await this.loadTransactionLines();
      if(this.selectedBudget != null){
        this.transaction.relatedTransactionId = this.selectedBudget?.id;
        this.loadRelatedTransactionInfo({ value: { id: this.transaction.relatedTransactionId } });
      }
      if(transactionLine==null && data) {
        this.editTransactionLine(isGroup, null, data.selectedCapability);
      }
      if(isGroup) this.updateOrderLines(); //En caso de grupo que ponga el numero del grupo.
      this.getTransactionLogs(); //Recargamos los logs.
      if(uploadDocument) this.loadTransactionFiles(); //Recargamos
    });
  }

  async deleteLine(transactionLine: TransactionLine) {

    if(this.transaction.netSuiteId != null && !this.allowChangeEvenNetSuiteId){
      this.messageService.add({ closable: true, severity: 'info', detail: "No se puede modificar una transacción que ha sido contabilizada." });
      return;
    }

    this.confirmationService.confirm({
      message: "¿Está seguro que desea eliminar la línea '" + transactionLine.description +"'?",
      header: "Eliminar línea",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.transactionsLinesService.delete(transactionLine.id).subscribe({
          next: (data: any) => {
            this.loadTransaction(this.transaction.id!);
            this.loadTransactionLines();
            this.getTransactionLogs(); //Cargamos el log
            this.messageService.add({ closable: true, severity: 'success', detail: "Línea eliminada correctamente." });
             if(this.transaction.relatedTransactionId != null){
              this.loadRelatedTransactionInfo({ value: { id: this.transaction.relatedTransactionId } });
            }
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      },
      reject: (error: any) => {
        if(error?.error) this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
      }
    });
  }

  async importJobs(){    

    if(this.transaction.netSuiteId != null && !this.allowChangeEvenNetSuiteId){
      this.messageService.add({ closable: true, severity: 'info', detail: "No se puede modificar una transacción que ha sido contabilizada." });
      return;
    }
    let ref = this.dialogService.open(TransactionLinesJobsComponent, {
      closable: true,
      modal: true,
      header: 'Importar trabajos',
      width: '50%',
      draggable: true,
      data: {                
        caseId: this.transactionFormGroup.get('caseId')?.value,
        transactionId: this.transaction.id,
        lineNumber: this.totalTransactionLines+1,
        isForCompany: this.transactionType.thirdPartyType == 'Worker' ? false : true
      }
    });

    ref.onClose.subscribe((data: any) => {
      this.loadTransactionLines();
      this.loadTransaction(this.transaction.id!);
      this.getTransactionLogs();
    });
      
  }
  async importExcel(){

    if(this.transaction.netSuiteId != null && !this.allowChangeEvenNetSuiteId){
      this.messageService.add({ closable: true, severity: 'info', detail: "No se puede modificar una transacción que ha sido contabilizada." });
      return;
    }

    let ref = this.dialogService.open(TransactionUploadExcelComponent, {
      closable: true,
      modal: true,
      header: 'Importar Excel',
      width: '600px',
      draggable: true,
      data: {
        transactionId: this.transaction.id
      }
    });

    ref.onClose.subscribe((messages: any) => {
      if(messages == null) return;

      //avisos de filas cuyo total no cuadraba con el calculado
      for(let message of messages){
        this.messageService.add({ closable: true, sticky: true, severity: message.severity, summary: message.summary, detail: message.detail });
      }

      this.loadTransactionLines();
      this.loadTransaction(this.transaction.id!);
      this.getTransactionLogs();
    });

  }

  get visibleColumnsCount(): number {
    let count = 3; 
    //if (this.transactionType.thirdPartyType === 'Company') count++; 
    if (this.transactionType.enableRate) count++; 
    if (this.transactionType.enablePrice) count += 3; 
    if (this.transactionType.enableDiscount) count++; 
    if (this.transactionType.enableTax) count++; 
    return count;
  }

  async checkAndsave(){
    if(this.transaction.netSuiteId != null && this.transaction.netSuiteId != "" && this.type != 'company_outgoing_delivery_note' && !this.allowChangeEvenNetSuiteId){
      this.messageService.add({ closable: true, severity: 'info', detail: "No se puede modificar una transacción que ya ha sido contabilizada." });
      return;
    }

    var state = await this.transactionStates.filter((state: any) => state.id == this.transactionFormGroup.get('transactionStateId')?.value)[0];

    if(typeof state != "undefined" && state!=null && state.enableStateNotes && this.transaction.transactionStateId!=null && this.transaction.transactionStateId!=state.id){
      this.showStateNotes = true;
    }else{
      this.save(true);
    }
  }

  saveStateNotes(notes: string){
    if(notes.length<25){
      this.messageService.add({ closable: true, severity: 'error', detail: "Las notas deben tener al menos 25 caracteres." });
    }else{
      this.showStateNotes = false;
      this.transactionFormGroup.patchValue({ transactionStateNotes: notes });
      
      this.save(true);
    }
    
  }
  async pdfTransaction(transactionType: string, transactionId: string){
      await this.save(false);
      const transactionContract = this.transaction.case?.contractId || undefined;
      const transactionCompany = this.transaction.case?.companyId || undefined;
      const caseId = this.transaction.case?.id || undefined;
      this.templateService.getTemplateId(transactionType, transactionContract, transactionCompany, transactionId, caseId).then((result:any) => {
        if(result != null){
          this.transactionsService.export(transactionId, result.templateId, result.metadata);
        }
      });
    }
  //Genera el documento de la transacción, lo guarda como fichero asociado a la transacción
  //y registra el evento en el histórico de la misma.
  async pdfTransactionAndSave(transactionType: string, transactionId: string){
     await this.save(false);
    const transactionContract = this.transaction.case?.contractId || undefined;
    const transactionCompany = this.transaction.case?.companyId || undefined;
    const caseId = this.transaction.case?.id || undefined;

    //si hay varias plantillas, getTemplateId abre el diálogo de selección y devuelve la elegida junto a su metadata
    const result: any = await this.templateService.getTemplateId(transactionType, transactionContract, transactionCompany, transactionId, caseId);
    if(result == null) return; //se ha cancelado la selección de plantilla
    if(result.templateId == null || result.templateId == ""){
      this.messageService.add({ closable: true, severity: 'error', summary: "Error", detail: "Debe seleccionar una plantilla de documento." });
      return;
    }

    try {
      //generamos el documento
      const pdfBlob: any = await this.transactionsService.exportTransaction(transactionId, result.templateId, result.metadata);
      if(pdfBlob == null) return;

      //lo abrimos en otra ventana
      window.open(window.URL.createObjectURL(pdfBlob), '_blank');

      const documentName = this.transactionType?.name ?? "Documento";
      //el fichero se nombra con el tercero de la transacción
      const thirdPartyName = this.transaction.thirdParty?.name ?? documentName;
      const fileName = (thirdPartyName + "_" + (this.transaction.code ?? "")).replace(/[\\/:*?"<>|]/g, "").replace(/\s+/g, "_") + ".pdf";

      //creamos el file
      let data: File = new File();
      data.fileName = fileName;
      data.description = documentName + " con código " + this.transaction.code + (this.transaction.case?.caseNumber != null ? " del expediente " + this.transaction.case.caseNumber : "");
      data.size = pdfBlob?.size ?? 0;
      data.contentType = "application/pdf";

      let fileResponse = await firstValueFrom(this.filesService.save(data));

      //subimos el contenido al file
      pdfBlob.fileName = fileName;
      await firstValueFrom(this.filesService.upload(fileResponse.id as string, pdfBlob));

      //asociamos el fichero a la transacción
      let transactionFile = new TransactionFile();
      transactionFile.transactionId = transactionId;
      transactionFile.fileId = fileResponse.id as string;
      await firstValueFrom(this.transactionsFileService.save(transactionFile));

      //registramos el evento en el histórico de la transacción
      let transactionLog = new TransactionLog();
      transactionLog.transactionId = transactionId;
      transactionLog.date = new Date();
      transactionLog.notes = "Se genera el fichero con nombre " + fileName + ". El valor actual de la transacción es de " +
        (this.transaction.total ?? 0).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + "€";
      await firstValueFrom(this.transactionsLogService.save(transactionLog));

      await this.loadTransactionFiles();
      await this.getTransactionLogs();

      this.messageService.add({ closable: true, severity: 'success', summary: "Éxito", detail: "Documento generado y añadido a la transacción." });
    } catch (error) {
      console.error(`Error al generar y guardar el documento de la transacción: ${error}`);
    }
  }

  async exportTransaction(transactionType: string, transactionId: string){

    this.templateService.getTemplateId(transactionType, undefined, undefined, transactionId).then((result:any) => {
       
      if(result != null){
        this.transactionsService.exportTransaction(transactionId, result.templateId, result.metadata).then(async result => {
          this.filePhoto = result;
          //var fileURL = URL.createObjectURL(result);           
          //Giuardamos el documento antes de enviarlo
          let data: File = new File();
          data.fileName = (transactionType != 'purchase_order' ?  "presupuesto_caso_" : "solicitud_compra ") + this.transaction.case.caseNumber + "_transaccion_" + this.transaction.code + ".pdf";
          data.description = (transactionType != 'purchase_order' ? "Presupuesto del caso " : "Solicitud de compra ") + this.transaction.case.caseNumber + " transacción con código " + this.transaction.code;
          data.size = this.filePhoto?.size ?? 0;
          data.contentType = "application/pdf";
          //data.path = file.name;
        
          //creamos el file
          let fileResponse = await firstValueFrom(this.filesService.save(data));
            
          this.filePhoto.fileName = (transactionType != 'purchase_order' ?  "presupuesto_caso_" : "solicitud_compra ") + this.transaction.case.caseNumber + "_transaccion_" + this.transaction.code + ".pdf";
          //subimos el fichero al file
          let response = await firstValueFrom(this.filesService.upload(fileResponse.id as string, this.filePhoto));
          
          this.filesIdsToSend.push(fileResponse.id as string);
          //obtenemos el email al que enviar el documento
          var email = "";

          var aux = this.thirdParties.filter( (m: any) => m.id == this.transaction.thirdPartyId);
           if(aux.length>0) email = aux[0].email;
          
          this.addComunication('Mail', email, true, true, transactionType);
        });
        
      }
    });
  }

  async downloadXml(transactionId: string) {
    const file = await this.transactionsService.exportXml(transactionId);
    //descargamos el blob
    const url = window.URL.createObjectURL(file);
    const a = document.createElement('a');
    a.href = url;
    a.download = this.transaction.code + ".xml";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  async sendToCaser(transactionId: string) {
    //sin try/catch a proposito: si la action falla, la promesa rompe, no se muestra el exito y del
    //error se encarga el HttpErrorInterceptor con el mensaje del backend
    await firstValueFrom(this.transactionsService.sendToCompany(transactionId));
    this.messageService.add({ closable: true, severity: 'success', detail: 'Solicitud de envío a la compañía registrada correctamente' });
  }

  addComunication(comunicationType:string|null, email:string|null, attachment: boolean = false, thirdpartySelector: boolean = false, transactionType: string = ""){
    let outgoingMailResourceType = ContractsOutgoingMailResourceType.Other;
    if(transactionType.indexOf('budget') !== -1) outgoingMailResourceType = ContractsOutgoingMailResourceType.Budget;
    let ref = this.dialogService.open(ComunicationsComponent, {
      closable: true,
      modal: true,
      header: 'Enviar documento',
      width: '60%',
      data: {
        caseId: this.caseId,
        model: this.transaction.case,
        comunicationType: comunicationType,
        email: email,
        attachments: (attachment ? this.filesIdsToSend: []),
        subject: "[" + this.transaction.case.caseNumber + "]" + (transactionType != 'purchase_order' ? " Presupuesto del caso " : " Solicitud de compra "),
        thirdpartySelector: thirdpartySelector,
        transaction: this.transaction,
        outgoingMailResourceType: outgoingMailResourceType
      }
    });

    ref.onClose.subscribe((data: any) => {
      this.cancel();
    });
  }


  async generatePayment() {
    await this.loadTaxes();   
    
    //Obtenemos una linea de la transacción para obtener el tipo de iva
    let params: IParamsCollection = {
      sort: ["lineNumber"]      
    }
    let filters: any = {
      transactionId: new Filter(FilterOperation.equals, "transactionId"),
    };

    filters.transactionId.value = this.transaction.id;
    params.filter = FilterBuilder.fromObject(filters).build();   
    
    let response = await firstValueFrom(this.transactionsLinesService.all(params));
    if(response.data.length > 0){
      this.payment.taxPercent = response.data[0].taxPercent;
      if( this.payment.taxPercent == null){
         this.payment.taxPercent = this.taxes.filter(m => m.code == "GENERAL")[0].percent;
      }
    }else{
      this.payment.taxPercent = this.taxes.filter(m => m.code == "GENERAL")[0].percent;    
    }

    this.displayPaymentModal = true;
    this.payment.date = new Date();
    this.payment.transactionTypeId = this.transaction.transactionTypeId;
    this.payment.price = this.transaction.subtotal;
    this.payment.total = this.transaction.total;       
    this.payment.isReturn = true; 
    this.payment.type = 'total';
    
    this.calculatePrices();

  }

  async savePayment(){
    if(this.payment.date == null){
      this.messageService.add({ severity: 'error', detail: 'La fecha del abono no puede ser nula.' });
      return;
    }
    if(this.payment.taxPercent == null){
      this.messageService.add({ severity: 'error', detail: 'La impuesto del abono no puede ser nulo.' });
      return;
    }
    if(this.payment.price == null){
      this.messageService.add({ severity: 'error', detail: 'La precio del abono no puede ser nulo.' });
      return;
    }


    const subtotal = Math.round(this.payment.subtotal * 100) / 100;
    const total = Math.round(this.transaction.total * 100) / 100;

    if (subtotal > total) {
      this.messageService.add({ severity: 'error', detail: 'El importe del abono no puede superar el total de la factura.' });
    } else {
      let data: any = {
        notes: this.payment.notes,
        transactionSelectedId: this.transaction.id,
        date: this.payment.date, // new Date(),
        price: this.payment.price,
        taxPercent: this.payment.taxPercent,
        taxAmount: this.payment.taxAmount,
        subtotal: this.payment.subtotal,
      };

      let result: any = await firstValueFrom(this.transactionsService.generatePaymentReturn(data));

      this.messageService.add({ closable: true, severity: 'success', summary: 'Abono guardado correctamente.' });
      this.displayPaymentModal = false;
      this.loadTransaction(this.transaction.id!);
    }
  }

  async loadTaxes() {
    this.loadingTaxes = true;
    let params: IParamsCollection = {
    }

    let response = await firstValueFrom(this.taxesService.all(params));
    this.taxes = response.data;

    this.loadingTaxes = false;
  }

  calculatePrices() {
    const price = this.payment?.price || 0;
    const taxPercent = this.payment?.taxPercent || 0;

    // Cálculo del importe de impuestos
    this.payment.taxAmount = price * (taxPercent / 100);

    // Cálculo del subtotal final con impuestos
    this.payment.subtotal = price + this.payment.taxAmount;
  }

  async onQuantityBlur(transactionLine: TransactionLine) {
    await this.onLineEditComplete(transactionLine);
  }

  copyText(text: string) {
    navigator.clipboard.writeText(text ?? "");
    this.messageService.add({ closable: true, severity: 'info', detail: "Descripción copiada al portapapeles" });
  }

  // Inserta un salto de línea en la posición del cursor (Ctrl+Enter), ya que Enter
  // confirma la edición igual que el resto de campos de la línea.
  insertLineBreak(event: Event, transactionLine: TransactionLine) {
    event.preventDefault();
    const textarea = event.target as HTMLTextAreaElement;
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const value = transactionLine.description ?? "";
    transactionLine.description = value.substring(0, start) + "\n" + value.substring(end);
    // Restauramos el cursor tras el salto una vez Angular ha actualizado el ngModel.
    setTimeout(() => {
      textarea.selectionStart = textarea.selectionEnd = start + 1;
    });
  }

  async onRateLineEditComplete(transactionLine: TransactionLine) {
    if(transactionLine == null) return;
  }

  async onLineEditComplete(transactionLine?: TransactionLine) {

    if(transactionLine == null) return;
    if((transactionLine?.jobId != null || (this.transaction.netSuiteId != null && !this.allowChangeEvenNetSuiteId))){
      return;
    }

    transactionLine.quantity = parseFloat(transactionLine.quantity?.toString() ?? "0");
    transactionLine.price = parseFloat(transactionLine.price?.toString() ?? "0");
    transactionLine.discountPercent = parseFloat(transactionLine.discountPercent?.toString() ?? "0");
    transactionLine.incrementPercent = parseFloat(transactionLine.incrementPercent?.toString() ?? "0");
    transactionLine.discountAmount = parseFloat(transactionLine.discountAmount?.toString() ?? "0");
    transactionLine.subtotal = parseFloat(transactionLine.subtotal?.toString() ?? "0");

    this.recalculateLinePrices(transactionLine);
    try {
      await firstValueFrom(this.transactionsLinesService.save(transactionLine));
      await this.loadTransaction(this.transaction.id!);
      await this.loadTransactionLines();
      if(this.selectedBudget != null){
        this.transaction.relatedTransactionId = this.selectedBudget?.id;
        this.loadRelatedTransactionInfo({ value: { id: this.transaction.relatedTransactionId } });
      }
      this.getTransactionLogs();
    } catch (error: any) {
      this.messageService.add({ closable: true, severity: 'error', detail: error?.error?.title ?? 'Error al guardar la línea.' });
    }
  }

  private recalculateLinePrices(line: TransactionLine) {

    const base = (line.quantity ?? 0) * (line.price ?? 0);
    let net = base;

    if (this.transactionType.enableDiscount) {
      if ((line.discountPercent ?? 0) > 0) {
        line.discountAmount = parseFloat((base * (line.discountPercent / 100)).toFixed(2));
        net = base - line.discountAmount;
        line.incrementAmount = 0;
      } else if ((line.incrementPercent ?? 0) > 0) {
        line.incrementAmount = parseFloat((base * (line.incrementPercent / 100)).toFixed(2));
        net = base + line.incrementAmount;
        line.discountAmount = 0;
      } else {
        line.discountAmount = 0;
        line.incrementAmount = 0;
      }
    }

    if (this.transactionType.enableTax) {
      line.taxAmount = parseFloat((net * ((line.taxPercent ?? 0) / 100)).toFixed(2));
    }

    line.subtotal = parseFloat(net.toFixed(2));
  }

   async selectFile(value: any, id: string | "empty"){
    if(this.transactionFilesIdToPDF.findIndex((m: any) => m == value) == -1){
      this.transactionFilesIdToPDF.push(value);
      this.transactionFilesIdChecked[id].push(value);
    }else{
      if(this.transactionFilesIdToPDF.findIndex((m: any) => m == value) != -1) this.transactionFilesIdToPDF.splice(this.transactionFilesIdToPDF.findIndex((m: any) => m == value), 1 );
      if(this.transactionFilesIdChecked[id].findIndex((m: any) => m == value)!=-1) this.transactionFilesIdChecked[id].splice(this.transactionFilesIdChecked[id].findIndex((m: any) => m == value), 1 );
    }
  }
  selectAll(event: any, id?: string | null ){
     this.transactionFilesIdChecked[id??"empty"] = [];//para pintarlo el otro array para mandarlo.   
    if(event.checked){
      if(id != "" && id != null){
        var filesservices =  this.caseFiles.filter((caseFile: CaseFile) => caseFile.caseServiceId == id);
        filesservices.forEach((caseFile: CaseFile) => {
          this.transactionFilesIdToPDF.push(caseFile.fileId);
          this.transactionFilesIdChecked[id].push(caseFile.fileId);
        });
      }else{
        this.caseFilesWithoutService.forEach((caseFile: CaseFile) => {
          this.transactionFilesIdToPDF.push(caseFile.fileId);
          this.transactionFilesIdChecked["empty"].push(caseFile.fileId);
        });
      }
    }
    else
    {
      if(id != "" && id != null){
        var filesservices =  this.caseFiles.filter((caseFile: CaseFile) => caseFile.caseServiceId == id);
        filesservices.forEach((caseFile: CaseFile) => {         
          if(this.transactionFilesIdToPDF.findIndex((m: any) => m == caseFile.fileId)!=-1) this.transactionFilesIdToPDF.splice(this.transactionFilesIdToPDF.findIndex((m: any) => m == caseFile.fileId), 1 );
        });
      }else{
        this.caseFilesWithoutService.forEach((caseFile: CaseFile) => {
          if(this.transactionFilesIdToPDF.findIndex((m: any) => m == caseFile.fileId)!=-1) this.transactionFilesIdToPDF.splice(this.transactionFilesIdToPDF.findIndex((m: any) => m == caseFile.fileId), 1 );
        });
      }
    }
  }

  fileIsAnImage(file: File) {
    return file.contentType.startsWith("image");
  }

  filesByService(serviceId: string) {
    return this.caseFiles.filter((caseFile: CaseFile) => caseFile.caseServiceId == serviceId);
  }

  toggleColumnTax($event: any){
    this.showTax = $event.checked;
  }

  async loadRateLines() {   

    var thirdPartyId = this.transaction.thirdPartyId;
    let typeStr = "COMPANY";
    if(this.type == "incoming_invoice") typeStr = "WORKER";
    if(this.type == "ingoing_budget_worker") typeStr = "WORKER";
    if(this.type == "outgoing_budget" || this.type == "affected_outgoing_budget"){
      //si es un presupuesto a cliente/afectado, hay que poner los baremos de la compañía del cliente/afectado
      thirdPartyId = this.transaction.case.companyId;
    }    
    this.allRateLines = await firstValueFrom(this.ratesService.rateLinesCompany(
      typeStr,
      thirdPartyId,
      this.transaction.date,
      this.transaction.case?.clientPolicy?.insuranceCompanyId ?? null,
      this.transaction.case?.contractId ?? null,
      false
    ));
    let capabilityIds = [...new Set(this.allRateLines.map((m: any) => m.capabilityId))];
    this.capabilities = this.allCapabilities.filter((m: any) => capabilityIds.includes(m.id));

  }

  async selectCapability(capability: any) {
    if(this.allRateLines.length == 0) await this.loadRateLines();
    this.rateLines = this.allRateLines.filter((m: any) => m.capabilityId == capability.value)
    this.rateLines.forEach((rateLine) => {
      rateLine.displayName = rateLine.code + (rateLine.description != null && rateLine.description != "" ? " - " + rateLine.description : "");
    }); 
  }
  getRate(id: string): Rate | undefined {
    return this.allRates.find((m: Rate) => m.id == id);
  }

  async onCellOpen(transactionLine: any){
    await this.selectCapability({ value: transactionLine.rateLine?.capabilityId });
  }
  // Asignar el precio unitario de la línea de tarifa al cambiar la línea de tarifa
  onRateLineChange(e: any, transactionLine: any) {
    var rateLineSelected = this.allRateLines.find((rateLine: any) => rateLine.id == e.value); 
    transactionLine.rateLineCode = rateLineSelected?.code || '';
    transactionLine.rateLineDescription = rateLineSelected?.description || '';
    transactionLine.price = rateLineSelected?.price || 0; // Asignar el precio de la línea de tarifa a la línea de transacción
    transactionLine.quantity = rateLineSelected?.fixedAmount != null ? rateLineSelected.fixedAmount : 1; 
    this.onLineEditComplete(transactionLine);
  }

  getTotalFromGroup(group: TransactionLine): any {
    const groupIndex = this.transactionLines.findIndex(l => l.lineNumber === group.lineNumber);
    const nextGroupIndex = this.transactionLines.findIndex(
      (l, i) => i > groupIndex && l.isGroup
    );
    const groupLines = this.transactionLines.slice(
      groupIndex + 1,
      nextGroupIndex === -1 ? undefined : nextGroupIndex
    );
    return {subtotal: groupLines.reduce((sum, l) => sum + (l.subtotal ?? 0), 0), total: groupLines.reduce((sum, l) => sum + ((l.subtotal ?? 0) + (l.taxAmount ?? 0)), 0)};
  }

  async duplicateLine(transactionLine: TransactionLine){
    this.confirmationService.confirm({
      message: "¿Está seguro que desea duplicar la transacción "+this.transaction.code+"?",
      header: "Duplicar transacción",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: async () => {         
        let newTransactionLine = new TransactionLine();
        newTransactionLine = transactionLine;
        newTransactionLine.id = '';
        newTransactionLine.lineNumber = transactionLine.lineNumber + 1;
        await firstValueFrom(this.transactionsLinesService.save(newTransactionLine));
        this.loadTransactionLines();
        this.getTransactionLogs();
      },
      reject: (error: any) => {
        this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
      }
    });
   
  }

  async getTransactionLogs(){
    var logs = await firstValueFrom(this.transactionsLogService.all({
        sort: ['-createdAt'],
        page: { number: 1, size: 1000 },
        include: ['createdByUser'],
        filter: FilterBuilder.fromObject({transactionId: new Filter(FilterOperation.equals, 'transactionId', '', this.id)}).build()}));
    this.transactionLogs = logs.data;
  }

  importTransactionLines(){
      if(this.caseSelected.caseState != null && this.caseSelected.caseState.isFinal) {
        this.messageService.add({ closable: true, severity: 'error', detail: "No se pueden modificar o crear trabajos en un expediente cerrado." });
        return;
      }

      let ref = this.dialogService.open(CaseServiceTransactionLinesComponent, {
        closable: true,
        header: 'Datos generales',
        width: '50%',
        draggable: true,
        modal: false,
        data: {        
          type: this.type == "ingoing_budget_worker" ? "WORKER" : "COMPANY",
          transactionId: this.transaction.id,
          transactionTypeEnableGroups: this.transactionType.enableGroup,
          companyId: this.caseSelected?.companyId,        
          caseId: this.caseId,
          caseServiceId: null,
          workerId: null,       
          providerId: null 
        }
      });
  
      ref.onClose.subscribe((data: any) => {      
        if(this.allowCopyTransactionLines){
          this.loadTransactionLines();
          this.loadTransaction(this.transaction.id!);
          this.getTransactionLogs();
        }
      });
    }

    async addRatesTemplate() {
      this.showSRateTemplates = true;

      //en los presupuestos de operario el titular del baremo es el operario, en el resto la compañía del expediente
      let isWorkerRate = this.type == "ingoing_budget_worker";
      //valores del enum TypeOfRate: 0 = Company, 1 = Worker
      let typeOfRate = isWorkerRate ? '1' : '0';

      //fecha contra la que se comprueba la vigencia, al inicio del día como hace el backend
      let today = new Date();
      today.setHours(0, 0, 0, 0);

      //baremos asignados al titular
      let ownerRateIds = await this.getOwnerRateIds(isWorkerRate);

      //el baremo debe ser del titular o estar marcado como general
      let ownerFilters: Filter[] = [new Filter(FilterOperation.equals, 'rate.isGeneral', '', true)];
      if(ownerRateIds.length > 0) {
        ownerFilters.push(new Filter(FilterOperation.any, 'rateId', '', ownerRateIds));
      }

      let filters: any = {
        typeOfRate: new Filter(FilterOperation.equals, 'rate.typeOfRate', '', typeOfRate),
        //vigente hoy: ya ha entrado en vigor y no ha caducado, o no tiene fecha de fin
        fromDate: new Filter(FilterOperation.lessOrEqual, 'rate.fromDate', '', today),
        toDate: new OrFilter([
          new Filter(FilterOperation.equals, 'rate.toDate', '', null, true),
          new Filter(FilterOperation.greaterOrEqual, 'rate.toDate', '', today)
        ]),
        owner: new OrFilter(ownerFilters)
      };

      let params:IParamsCollection = {
        sort: ['name'],
        include: ['rate'],
        filter: FilterBuilder.fromObject(filters).build()
      };

      let response = await firstValueFrom(this.ratesTemplatesService.all(params));
      this.rateTemplates = response.data;

    }

    /**
     * Identificadores de los baremos asignados al titular del documento: el operario en los
     * presupuestos de operario y la compañía del expediente en el resto.
     */
    private async getOwnerRateIds(isWorkerRate: boolean): Promise<string[]> {
      let rateIds: string[] = [];

      if(isWorkerRate) {
        if(this.transaction.thirdPartyId == null || this.transaction.thirdPartyId == "") return rateIds;
        let response = await firstValueFrom(this.workerRatesService.all({
          page: { size: 500 },
          filter: FilterBuilder.fromObject({
            workerId: new Filter(FilterOperation.equals, 'workerId', '', this.transaction.thirdPartyId)
          }).build()
        }));
        rateIds = response.data.map((workerRate: WorkerRate) => workerRate.rateId);
      }else{
        let companyId = this.caseSelected?.companyId;
        if(companyId == null || companyId == "") return rateIds;
        let response = await firstValueFrom(this.companyRatesService.all({
          page: { size: 500 },
          filter: FilterBuilder.fromObject({
            companyId: new Filter(FilterOperation.equals, 'companyId', '', companyId)
          }).build()
        }));
        rateIds = response.data.map((companyRate: CompanyRate) => companyRate.rateId);
      }

      //descartamos los que no tengan baremo y los repetidos
      return rateIds.filter((rateId: string, index: number) => rateId != null && rateIds.indexOf(rateId) == index);
    }

    async saveRateTemplates(rateTemplateId: string){
      //this.loadingRateTemplateLines = true
      let params: IParamsCollection = {
        include: ['rateLine']
      }
      let filters: any = {
        rateTemplateId: new Filter(FilterOperation.equals, "rateTemplateId", "", this.rateTemplateId),
      };
      params.filter = FilterBuilder.fromObject(filters).build();
  
      let response = await firstValueFrom(this.ratesTemplatesLinesService.all(params));
      const idx = 0;
      for (const line of response.data) {
        //se inserta si no es grupo o si lo es, si el destino acepta grupos.
          let newTransactionLine: TransactionLine = new TransactionLine();
          newTransactionLine.transactionId = this.id;
          newTransactionLine.lineNumber = this.totalTransactionLines + 1;
          newTransactionLine.quantity = line.quantity;
          newTransactionLine.description = line.description;
          newTransactionLine.rateLineId = line.rateLineId;
          newTransactionLine.rateLineCode = line.rateLine.code;
          newTransactionLine.price = line.rateLine.price;
          await firstValueFrom(this.transactionsLinesService.save(newTransactionLine));
      }
      this.loadTransactionLines();
      this.loadTransaction(this.transaction.id!);
      this.getTransactionLogs();
      this.showSRateTemplates = false;
    }
}
